module.exports = __webpack_public_path__ + "img/culture_icon4.53f9c8fb.png";